import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  LinearProgress,
} from '@mui/material';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import { memo, useState } from 'react';
import SimpleSearchInput from 'components/SearchInputNavbar';
import moment from 'moment';
import { useQuery } from 'react-query';
import IncomeMoneyFilterDrawer from '../../../components/dashboard/IncomeMoneyFilterDrawer';
import { useLocation } from 'react-router-dom';

const Money = () => {
  const { search } = useLocation();

  const axiosPrivate = useAxiosPrivate();

  const [openModal, setOpenModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);

  const { isLoading, data, refetch } = useQuery({
    queryKey: ['/dictionary/accpetedpayments', search],
    queryFn: async () => {
      const response = await axiosPrivate.get(
        `/dictionary/accpetedpayments${search || ''}`
      );
      return response.data?.data;
    },
  });

  return (
    <div className='component-list-wrapper'>
      <div className='component-list-header mb-2'>
        <div className='header-actions-container py-3 flex flex-row items-center'>
          <div className='header-actions filter-box flex items-center px-4 w-full'>
            <Button
              variant='base'
              color='primary'
              startIcon={<i className='bi bi-filter' />}
              className='!mr-2'
              onClick={() => setOpenFilter(true)}
            >
              Filter
            </Button>
            <SimpleSearchInput inputKey='name' />
          </div>
          <div className='header-actions action-buttons-box py-3 px-4 flex gap-2 items-center justify-center'>
            <Button
              variant='base'
              color='info'
              onClick={() => refetch()}
              disabled={isLoading}
            >
              <i
                className={`bi bi-arrow-repeat${
                  isLoading ? ' animate-spin' : ''
                }`}
              />
            </Button>
            <Button
              variant='base'
              color='success'
              onClick={() => setOpenModal(true)}
            >
              <i className='bi bi-plus-circle' />
            </Button>
            <Button
              variant='base'
              color='default'
              onClick={() => setOpen(true)}
            >
              <i className='bi bi-gear' />
            </Button>
          </div>
        </div>
      </div>

      <div className='component-table-wrapper h-[calc(100vh-180px)]'>
        <TableContainer className='tab-table-container' component='div'>
          <Table stickyHeader component='div'>
            <TableHead component='div'>
              <TableRow component='div'>
                <TableCell component='div'>Sana</TableCell>
                <TableCell component='div'>To'lov id</TableCell>
                <TableCell component='div'>UZS | USD</TableCell>
                <TableCell component='div'>Izoh</TableCell>
              </TableRow>
            </TableHead>
            {isLoading ? (
              <TableBody component='div'>
                <TableRow>
                  <TableCell colSpan={'5'}>
                    <LinearProgress />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <TableBody component='div'>
                {data?.length > 0 ? (
                  data?.map((row) => (
                    <TableRow key={row?.id} component='div' hover>
                      <TableCell component='div'>
                        {moment(row?.date)?.format('DD/MM/YYYY')}
                      </TableCell>
                      <TableCell component='div'>{row?.ext_id}</TableCell>
                      <TableCell component='div'>
                        {row?.sum} | {row?.valute}
                      </TableCell>
                      <TableCell component='div'>{row?.comment}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow component='div'>
                    <TableCell align='center' colSpan={'5'}>
                      Maʼlumot topilmadi
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </div>

      {openModal && null}

      <IncomeMoneyFilterDrawer open={openFilter} setOpen={setOpenFilter} />
    </div>
  );
};

export default memo(Money);
